import i18n from '@/api/i18n/i18n';

const actionDict = {
  38: i18n.t('pages.actionDict.connectionStart'),
  39: i18n.t('pages.actionDict.connectionEnd'),
};

export const action = (val) => actionDict[val];
